export default __webpack_public_path__ + "static/media/social_share-red.10f9bc6f.png";